<template>
    <pre class="tabs">
<b>Tuning: EADGBe (Standard Tuning)

PM palm mute
/  slide up
\  slide down
h  hammer-on
p  pull-off
b  bend
d  down
~  vibrato
+  harmonic
x  mute note

TAB:</b>

INTRO, ALL VERSE
Variation 1

e|-----------------x-x-x-------------x--|
B|--5-55-----------x-x-x-------------x--|
G|--4-44-----------x-x-x-1-11--3-333-x--|
D|--3-33-----------x-x-x-2-22--4-444-x--|
A|--4-44-2--4~--p2-x-x-x-2-22--4-444-x--|
E|-----------------x-x-x-0-00--2-222-x--|

PRE-CHORUS
Variation 1

    PMPMPMPMPMPM                      PMPMPMPMPMPM
e|--------------------5/14---------------------------------------|
B|-------------------------5/14\5--------------------------------|
G|---------------------------------------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|--9-9\3-3-3\0--0--------------------9-9\3-3-3\0--0-------------|

Variation 2

    PMPMPMPMPMPM                      PMPMPMPMPMPM
e|---------------------------------------------------------------|
B|---------------------------------------------------------------|
G|-----------------------11b13~----------------------------------|
D|---------------------------------------------------------------|
A|---------------------------------------------------------------|
E|--9-9\3-3-3\0--0--------------------9-9\3-3-3\0--0-------------|

CHORUS
Variation 1

    PMPMPMPM  PMPM  PMPM PM PM  PMPMPMPM  PMPM PM   PM    PMPMPMPM
e|---------------------------------------------------------------|
B|---------------------------------------------------------------|
G|------------------------------------------------66---6---------|
D|----------2---------------------------2------------------------|
A|--7-6-4-2---4-4---4-4--4--4---7-6-4-2---4-4--44----4----7-6-4-2|
E|---------------------------------------------------------------|
     PMPM
e|------------------------|
B|------------------------|
G|------------------------|
D|-2----------------5--6--|
A|---4-4--7-4h6-4-2-5--6--|
E|------------------3--4--|

Variation 2

    PMPMPMPM  PMPM  PMPM PM PM  PMPMPMPMPMPMPMPM  PM         PMPM
e|---------------------------------------------------9---9-------|
B|----------------------------------------5----------------------|
G|------------------------------9-6h8-8-4---6-6---66---6---------|
D|----------2--------------------------------------------------66|
A|--7-6-4-2---4-4---4-4--4--4--------------------------------7---|
E|---------------------------------------------------------------|

    PMPMPMPMPMPMPMPMPMPMPMPMPMPM  PMPM
e|---------------------------------------------------|
B|---------------------------------------------------|
G|---------------------------------------------------|
D|----------2---66----66----6------------------5--6--|
A|--6-4-2-2---4----44----44---4---4-4--7-6-4-2-5--6--|
E|---------------------------------------------3--4--|

Variation 3

    PMPMPMPM  PMPM  PMPM PM PM  PMPMPMPM  PMPM PM   PM    PMPMPMPM
e|-----------------------------------------------------9---------|
B|---------------------------------------------------------------|
G|------------------------------------------------66-------------|
D|----------2---------------------------2-------------------66---|
A|--7-6-4-2---4-4---4-4--4--4---7-6-4-2---4-4--44----4----7----6-|
E|---------------------------------------------------------------|

   PM PMPM PMPMPMPM PM PM PMPMPM
e|------------------------------------------------|
B|------------------------------------------------|
G|------------------------------------------------|
D|-66---66---2---66----6--4-6-7-6~----------5--6--|
A|----4----2---4----44--------------7-6-4-2-5--6--|
E|------------------------------------------3--4--|

BREAK
Variation 1

e|---------------------------------------------------------------|
B|---------------------------------------------------------------|
G|-11b13-10b11--11b13-10b11-----------11b13-10b11----------------|
D|--------------------------11+-14b16-------------11-11-14-11--11|
A|---------------------------------------------------------------|
E|---------------------------------------------------------------|

<b>SEQUENCE:</b>

INTRO
Variation 1 x4

VERSE 1
Variation 1 x4

PRE-CHORUS
Variation 1

CHORUS 1
Variation 1

BREAK 1
Variation 1

VERSE 2
Variation 1 x4

PRE-CHORUS
Variation 2

CHORUS 2
Variation 2

CHORUS 3
Variation 3

Tab Written By: D. WATERMELONE
    </pre>
</template>
<script>
export default {
    name: 'FancyClothes'
}
</script>
